import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Jellis Enterprise";
const DEFAULT_DESC =
  "Digital marketing that moves the needle — SEO, Google Ads, and social strategy built to bring local businesses more calls, leads, and revenue. Little Rock, Arkansas.";
const DEFAULT_IMG =
  "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwdGVhbXxlbnwwfHx8fDE3ODc2MDU5NTd8MA&ixlib=rb-4.1.0&q=85";

// Manages document title + meta + Open Graph / Twitter cards per page.
const Seo = ({ title, description, image, type = "website" }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Digital Marketing Agency in Arkansas`;
  const desc = description || DEFAULT_DESC;
  const img = image || DEFAULT_IMG;
  const url = typeof window !== "undefined" ? window.location.href : "";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
